import {PROPERTY_SELECTOR_SIGIL} from '../../constants';

export default function isValuePropertySelector(value) {
	if (typeof value !== 'string') return false;

	return value.startsWith(PROPERTY_SELECTOR_SIGIL);
}
